/* ==========================================================================
   DIDO — ATELIER · Custom JS (loaded after theme.js)
   Page-enter flag + cascading reveal stagger + dynamic search. No deps.
   ========================================================================== */
(function () {
  'use strict';

  /* Page-enter flag drives the settle-in animation. */
  requestAnimationFrame(function () { document.documentElement.classList.add('js-loaded'); });

  /* Give reveal siblings a cascading delay so grids ripple in. Resets per parent. */
  function applyStagger(scope) {
    var groups = new Map();
    (scope || document).querySelectorAll('[data-reveal]').forEach(function (el) {
      var parent = el.parentElement;
      var i = groups.get(parent) || 0;
      el.style.setProperty('--reveal-i', Math.min(i, 8));
      groups.set(parent, i + 1);
    });
  }
  applyStagger(document);
  document.addEventListener('shopify:section:load', function (e) { applyStagger(e.target); });
})();

/* ---------- Dynamic predictive search ---------- */
(function () {
  'use strict';
  var input = document.querySelector('[data-predictive-input]');
  var results = document.querySelector('[data-predictive-results]');
  if (!input || !results) return;

  var timer;
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function render(products, q) {
    if (!products.length) {
      results.innerHTML = '<p class="search-panel__empty">No matches for “' + esc(q) + '”.</p>';
      return;
    }
    results.innerHTML = products.map(function (p) {
      var img = p.image || (p.featured_image && p.featured_image.url) || '';
      return '<a class="search-result" href="' + p.url + '">' +
        (img ? '<img src="' + img + '" alt="" width="56" height="70" loading="lazy">' : '<span class="search-result__ph"></span>') +
        '<span class="search-result__info">' +
        '<span class="search-result__title">' + esc(p.title) + '</span>' +
        (p.price ? '<span class="search-result__price">' + esc(p.price) + '</span>' : '') +
        '</span></a>';
    }).join('');
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; return; }
    timer = setTimeout(function () {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, q);
        })
        .catch(function () { /* noop */ });
    }, 220);
  });

  /* Focus the field when the search drawer opens. */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open="search-drawer"]')) {
      setTimeout(function () { input.focus(); }, 320);
    }
  });
})();
